import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';
import { useSelector } from 'react-redux';
import { produktgruppenByNrSelector, produktgruppenSelector } from 'store/lookups/selector';

interface ProduktgruppeByNrProps {
    label: string;
    disabled: boolean;
    value: number | null;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    renderLabel?: 'label' | 'placeholder' | 'no';
    onChange: (newValue: number) => void;
}

export const ProduktgruppeByNr: React.FC<ProduktgruppeByNrProps> = ({
    label,
    value,
    disabled,
    menuPlacement = 'bottom',
    allowEmpty = false,
    renderLabel = 'label',
    onChange,
}) => {
    const produktgruppen = useSelector(produktgruppenSelector);
    const produktgruppenByNr = useSelector(produktgruppenByNrSelector);

    const options = React.useMemo(() => {
        const o = produktgruppen
            .sort((a, b) => a.text.localeCompare(b.text))
            .map((pg) => ({
                value: pg.nr.toString(),
                label: pg.text,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [produktgruppen, allowEmpty]);

    return (
        <>
            {renderLabel === 'label' && <Label>{label}</Label>}
            <Select
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    value
                        ? {
                              value: value.toString(),
                              label: produktgruppenByNr[value]?.text || value.toString(),
                          }
                        : null
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value ? parseInt(option?.value, 10) || 0 : 0);
                }}
                placeholder={renderLabel === 'placeholder' ? 'Produktgruppe' : ''}
            />
        </>
    );
};
